export default __webpack_public_path__ + "static/media/Save.b7c9d9ee.svg";